// @flow
import * as React from 'react';
import { Breadcrumbs, Button, Container, Divider, Link as MuiLink, Stack, Typography } from '@mui/material';
import {
  Portal, useAgentByContextSuspenseQuery, useAgentGmailAuthUrlLazyQuery, useIsAgentGmailSetUpSuspenseQuery
} from '../../shared';
import { Suspense } from 'react';
import { Preloader } from '@coverright/features';
import { Link } from 'react-router-dom';
import { getRoute } from '../../app/router';

export const Integrations = () => {
  return (
    <Container maxWidth={'sm'} sx={{mt: 2}}>
      <Breadcrumbs aria-label="breadcrumb">
        <MuiLink component={Link}
                 underline="hover" color="inherit"
                 to={`/${getRoute('profile')}`}>
          Settings
        </MuiLink>
        <Typography>Integrations</Typography>
      </Breadcrumbs>

      <Divider sx={{mb: 2, mt: 1}} />

      <Stack gap={3}>
        <Typography variant="subtitle1">Integrations</Typography>

        <Portal p={2}>
          <img src={'/assets/gmail-logo.jpg'} width={100} height={'auto'} />

          <Divider sx={{my: 2, mx: -2}} />

          <Suspense fallback={<Preloader sx={{ minHeight: 100 }} />}>
            <Form />
          </Suspense>
        </Portal>

      </Stack>
    </Container>
  );
};


const Form = () => {
  const [getUrl] = useAgentGmailAuthUrlLazyQuery()
  const {data} = useAgentByContextSuspenseQuery();
  const agentId = data.agentByContext.id;

  const {data: gmailData} = useIsAgentGmailSetUpSuspenseQuery({
    variables: {agentId},
    skip: !agentId
  });

  const connected = gmailData.isAgentGmailSetUp

  const onIntegrateClick = async () => {
    const url = await getUrl().then(res => res.data?.agentGmailAuthUrl);
    if (url) {
      window.location.href = url;
    }
  }

  if (!connected) {
    return <Button variant={'outlined'} sx={{gap: 1}} onClick={onIntegrateClick}>
      Connect with
      <img src={'/assets/gmail-logo.jpg'} width={70} height={'auto'} />
    </Button>
  } else {
    return <Stack gap={2} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
      <img src={'/assets/gmail-logo.jpg'} width={70} height={'auto'} />
      <Typography color={'text.secondary'}>Connected</Typography>
    </Stack>
  }

}
